import { createOptionalContext } from '../../utils/hooks/create-optional-context.mjs';

const [RadioGroupProvider, useRadioGroupContext] = createOptionalContext();

export { RadioGroupProvider, useRadioGroupContext };
